<template>
    <div class="center-page">
        <el-page-header style="margin-bottom: 20px;" @back="$router.back()"
                        :content="`${id?'编辑':'新增'}路线`"></el-page-header>
        <el-form :model="addForm" :rules="rules" label-position="right" label-width="150px" ref="forms">
            <el-form-item label="封面照片：" prop="cover">
                <el-upload
                        action=""
                        class="avatar-uploader"
                        :http-request="uploadCover"
                        :show-file-list="false">
                    <img v-if="addForm.cover" :src="`/api/v1/file/${addForm.cover}`" class="avatar" alt="">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="详细照片：" required>
                <transition-group tag="div" name="drag" class="img-content">
                    <img @dragstart="handlerStart(item,index)"
                         @dragend="handlerEnd(item,index)"
                         @dragenter="handlerEnter(item,index)"
                         @click="delImg(index)"
                         v-for="(item,index) in addForm.image"
                         :key="item"
                         class="img-content-item" :src="`/api/v1/file/${item}`" alt="">
                    <el-upload
                            action=""
                            key="upload"
                            :http-request="uploadImage"
                            class="avatar-uploader"
                            :show-file-list="false">
                        <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                    </el-upload>
                </transition-group>
            </el-form-item>
            <el-form-item label="路线标题：" prop="route">
                <el-input style="width: 50%;" v-model="addForm.route" placeholder="路线标题"></el-input>
            </el-form-item>
            <el-form-item label="路线介绍：" prop="content">
                <el-input type="textarea"
                          v-model="addForm.content"
                          placeholder="请输入路线介绍"
                          :autosize="{ minRows: 8, maxRows: 16}"
                          maxlength="5000" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="游玩天数：" prop="play_time">
                <el-input-number :min="1" :step="1" v-model="addForm.play_time"></el-input-number>
            </el-form-item>
            <el-form-item label="预定须知：" prop="prompt">
                <el-input type="textarea"
                          v-model="addForm.prompt"
                          placeholder="请输入预定须知"
                          :autosize="{ minRows: 4, maxRows: 8}"
                          maxlength="1000" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="类型：" prop="price">
                <el-select v-model="addForm.is_bao">
                    <el-option v-for="(item,index) in typeList" :key="index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="价格设定：" prop="price">
                <el-input style="width: 30%;" v-model="addForm.price" placeholder="请输入价格">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                </el-input>
                <div class="ml-20">价格的“10%”为乘客服务费</div>
            </el-form-item>
            <el-form-item>
                <el-button v-if="id" type="primary" v-loading="loading" @click="touristEdit">保存</el-button>
                <el-button v-else type="primary" v-loading="loading" @click="touristAdd">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {formVerify, delToast} from '@/utlis/decorators'

    export default {
        name: "addLine",
        data() {
            return {
                id: '',
                loading: false,
                typeList: [
                    {id: 1, name: '包车'},
                    {id: 2, name: '导游'},
                ],
                addForm: {
                    cover: '',//封面图
                    image: [],//图片
                    route: '',
                    price: '',
                    content: '',
                    play_time: '',
                    prompt: '',
                    is_bao: 1
                },
                rules: {
                    cover: [{required: true, message: '请上传封面', trigger: ['blur', 'change']}],
                    route: [{required: true, message: '请输入车辆名称', trigger: ['blur', 'change']}],
                    play_time: [{required: true, message: '请输入游玩天数', trigger: ['blur', 'change']}],
                    content: [{required: true, message: '请输入路线介绍', trigger: ['blur', 'change']}],
                    prompt: [{required: true, message: '请输入预定须知', trigger: ['blur', 'change']}],
                },
                start: '',
                startIndex: '',
                end: '',
                endIdnex: '',
                airport: []
            }
        },
        computed: {
            ...mapState(['cityList', 'paramsData'])
        },
        created() {
            let id = this.$route.query.id;
            if (id) {
                this.id = id;
                this.initEdit()
            }
        },
        methods: {
            initEdit() {
                let {
                    cover,
                    image,
                    route,
                    price,
                    cost_price,
                    content,
                    play_time,
                    prompt,
                    is_bao
                } = this.paramsData;
                this.addForm = {
                    cover,
                    image,
                    route,
                    price: cost_price,
                    content,
                    play_time,
                    prompt,
                    is_bao
                }
            },
            @delToast('是否删除该图片？')
            async delImg(index) {
                this.addForm.image.splice(index, 1)
            },
            async uploadCover(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.cover = data.result;
                }
            },
            async uploadImage(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.image.push(data.result);
                }
            },
            handlerStart(item, index) {
                this.start = item
                this.startIndex = index
            },
            handlerEnd(item, index) {
                if (this.startIndex === this.endIdnex) return;
                this.addForm.image.splice(this.startIndex, 1, this.end);
                this.addForm.image.splice(this.endIdnex, 1, this.start);
            },
            handlerEnter(item, index) {
                this.end = item
                this.endIdnex = index
            },
            @formVerify()
            async touristAdd() {
                this.loading = true;
                let [e, data] = await this.$api.touristAddApi(this.addForm);
                this.loading = false;
                if (data.status) {
                    this.$message.success('提交成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.result)
                }
            },
            @formVerify()
            async touristEdit() {
                this.loading = true;
                let [e, data] = await this.$api.touristEditApi({id:this.id, ...this.addForm});
                this.loading = false;
                if (data.status) {
                    this.$message.success('保存成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.result)
                }
            },
        },
    }
</script>

<style scoped lang="less">
    .img-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .img-content-item {
            width: 150px;
            height: 150px;
            object-fit: cover;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

    .drag-move {
        transition: 0.3s;
    }
</style>

